export default __webpack_public_path__ + "static/media/servicesImage.c6fb5c55.png";